import { Injectable } from '@angular/core';
import { FidelityPageService } from 'app/core/services/fidelity-page.service';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResult } from '../types/api-result.types';
import { GetCountriesResponse } from './countries.types';

@Injectable({
    providedIn: 'root',
})
export class CountriesService extends FidelityPageService {
    private countryCacheKey = `${this.constructor.name}`;

    getCountries(): Observable<ApiResult<GetCountriesResponse>> {
        if (this.memoryCacheService.has(this.countryCacheKey)) {
            return of(this.memoryCacheService.get(this.countryCacheKey));
        }

        return this.http.get<ApiResult<GetCountriesResponse>>(`${environment.apiUrl}/countries`).pipe(
            catchError(this.handleError),
            tap((res) => this.memoryCacheService.set(this.countryCacheKey, res))
        );
    }
}
